import React, { Component } from 'react';

const BUNDLE_RECOVERY_KEY = "bankco_bundle_recovery_attempted";

const getErrorText = (error, errorInfo) => [
  error?.name,
  error?.message,
  error?.stack,
  errorInfo?.componentStack,
].filter(Boolean).join("\n");

const isRecoverableBundleError = (error, errorInfo) => {
  const errorText = getErrorText(error, errorInfo);

  return errorText.includes("ChunkLoadError")
    || errorText.includes("Loading chunk")
    || errorText.includes("Failed to fetch dynamically imported module")
    || (
      errorText.includes("Cannot read properties of undefined (reading 'call')")
      && errorText.includes("__webpack_require__")
    );
};

const reloadWithFreshBundle = () => {
  if (typeof window === "undefined") return false;

  const recoveryKey = `${BUNDLE_RECOVERY_KEY}:${window.location.pathname}`;

  try {
    if (window.sessionStorage.getItem(recoveryKey)) return false;
    window.sessionStorage.setItem(recoveryKey, "true");
  } catch {
    return false;
  }

  const reload = () => window.location.reload();

  if (window.caches?.keys) {
    window.caches.keys()
      .then((cacheNames) => Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName))))
      .finally(reload);
    return true;
  }

  reload();
  return true;
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an external service here.
    console.error("Error caught by ErrorBoundary: ", error, errorInfo);

    if (isRecoverableBundleError(error, errorInfo)) {
      reloadWithFreshBundle();
    }
  }

  render() {
    if (this.state.hasError) {
      // Render the fallback UI.
      return this.props.fallback || <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
